import React from 'react'
import './App.css'

import Layout from './hoc/Layout'

const App = () => <Layout />

export default App
